<form [formGroup]="tenderDateTimeForm">
  <div class="date-time-block">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Tender open date</p>
      <mat-form-field>
        <mat-label>dd / mm / yyyy</mat-label>
        <input
          matInput
          formControlName="OpenDate"
          [matDatepicker]="pickerOpenDate"
          id="openDatedPicker"
          [min]="minDate"
          [readonly]="isReadOnly"
          (dateChange)="onStartDateChange()"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="pickerOpenDate"
          [disabled]="isReadOnly"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerOpenDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Start time</p>
      <mat-form-field>
        <mat-label>hh : mm</mat-label>
        <input
          matInput
          formControlName="StartTime"
          id="openDatedPicker"
          [readonly]="isReadOnly"
          pattern="([01][0-9]|2[0-3]):[0-5][0-9]"
        />
        <mat-error>Invalid time format. Please use HH:MM format.</mat-error>
        <mat-icon class="time-icon">access_time</mat-icon>
      </mat-form-field>
    </div>
    <div class="sub-text paragraph-small-regular">The start date of the bidding process.</div>
  
    <mat-icon tp="{{ tooltipInfo }}" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
  </div>
  <div class="date-time-block">
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">Tender close date</p>
      <mat-form-field >
        <mat-label>dd / mm / yyyy</mat-label>
        <input
          matInput
          formControlName="CloseDate"
          [matDatepicker]="pickerCloseDate"
          id="closeDatedPicker"
          [min]="minDate"
          [readonly]="isReadOnly"
          [matDatepickerFilter]="boundFilterCloseDate"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="pickerCloseDate"
          [disabled]="isReadOnly"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerCloseDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="form-inputs form-dropdown">
      <p class="paragraph-medium-regular">End time</p>
      <mat-form-field>
        <mat-label>hh : mm</mat-label>
        <input
          matInput
          formControlName="EndTime"
          id="openDatedPicker"
          [readonly]="isReadOnly"
          pattern="([01][0-9]|2[0-3]):[0-5][0-9]"
        />
        <mat-error>Invalid time format. Please use HH:MM format.</mat-error>
        <mat-icon class="time-icon">access_time</mat-icon>
      </mat-form-field>
    </div>
    <div class="sub-text paragraph-small-regular">
      The end date by which all proposals or bids must be submitted.
    </div>

    <mat-icon tp="{{ tooltipInfo }}" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">help</mat-icon>
  </div>
</form>
